declare interface CallbackOption {
    isAreaFree?: () => boolean;
    containStation?: (areaId: string, stationId: string) => boolean;
}

export const enum ConnectionType {
    B,
    C
}

export const enum PlaylistType {
    LIVE,
    VOD
}

export class PlaylistManager {
    private _areaId: string;
    private _stationId: string;
    private _playlistType: PlaylistType;

    constructor(private _options?: CallbackOption) {}

    set areaId(value: string) {
        this._areaId = value;
    }
    set stationId(value: string) {
        this._stationId = value;
    }
    set playlistType(value: PlaylistType) {
        this._playlistType = value;
    }

    get connectionType() {
        return this.allocateConnection() === ConnectionType.B ? 'b' : 'c';
    }

    public allocateConnection() {
        return this.containStation(this._areaId, this._stationId) || !this.isAreaFree() ? ConnectionType.B : ConnectionType.C;
    }

    /**
     * APIのレスポンス内容からエンドポイントを抽出する
     * @param {Document} xml
     */
    public extractEndpoints(xml: Document): string[] {
        const connectionType = this.allocateConnection();
        const urls: string[] = Array.from(xml.getElementsByTagName('url'))
            .filter(this.filterByPlaylistType(this._playlistType))
            .filter(this.filterByConnectionType(connectionType))
            .map((node) => {
                return (<Element>node.querySelector('playlist_create_url')).textContent || '';
            });

        if (urls.length === 0) {
            throw 'not found playlist_create_url';
        }

        return urls;
    }

    /**
     * プレイリストのタイプ(vodかliveか)によってフィルタリングする
     *
     * @param {PlaylistType} type
     * @returns {() => boolean}
     */
    public filterByPlaylistType(type: PlaylistType): (element: Element) => boolean {
        return (element: Element): boolean => {
            const vod = element.getAttribute('timefree');
            return (vod !== null && +vod === type);
        }
    }

    /**
     * 接続先回線の情報によってフィルタリングする
     */
    public filterByConnectionType(connectionType: ConnectionType): (element: Element) => boolean {
        return (element: Element): boolean => {
            const areaFree = element.getAttribute('areafree');
            return (areaFree !== null && +areaFree === connectionType);
        }
    }

    private isAreaFree(): boolean {
        if (this._options && this._options.isAreaFree) {
            return this._options.isAreaFree();
        } else {
            return false;
        }
    }

    private containStation(areaId: string, stationId: string): boolean {
        if (this._options && this._options.containStation) {
            return this._options.containStation(areaId, stationId);
        } else {
            return false;
        }
    }
}